import { useClickAway } from 'ahooks';
import { setAppUiState, useAiHistory } from 'src/services/app/hook';
import { ChatHistory } from '@flowus/common/chat-ai/pages/chat-history';
import { useCurrentSpace } from 'src/hooks/space';
import { useHistory } from 'react-router-dom';
import { ViewPath } from '@flowus/common/static-const';
import type { CSSProperties } from 'react';
import { TransitionBox } from 'src/common/components/transition-box';
import { cx } from '@flowus/common/cx';
import { useState, useEffect, useRef } from 'react';

interface Props {
  style?: CSSProperties;
}
export const AiHistoryList = (props: Props) => {
  const { style } = props;
  const ref = useRef(null);
  const show = useAiHistory();
  const currentSpace = useCurrentSpace();
  const history = useHistory();
  const [mounted, setMounted] = useState(false);

  const handleClose = () => {
    setAppUiState({ $showAiHistory: false });
  };

  useClickAway(handleClose, ref);

  useEffect(() => {
    if (show) {
      setMounted(true);
    }
  }, [show]);

  if (!mounted) return null;

  return (
    <TransitionBox
      domRef={ref}
      className={cx(
        'fixed top-0 left-0 w-80 next-modal max-h-screen h-screen z-[90] animate__animated animate__faster rounded-none',
        show ? 'animate__fadeInLeft' : 'animate__fadeOutLeft'
      )}
      style={style}
      onClick={(e) => e.stopPropagation()}
      onAnimationEnd={() => {
        if (!show) {
          setMounted(false);
        }
      }}
    >
      <ChatHistory
        onBack={handleClose}
        onNew={() => {
          history.push(ViewPath.chat);
          handleClose();
        }}
        onClick={(id) => {
          history.push(`${ViewPath.chat}/${id}`);
          handleClose();
        }}
        spaceId={currentSpace?.uuid}
      />
    </TransitionBox>
  );
};
